import React from "react";
import { FaMapMarkerAlt } from "react-icons/fa";

const ContactPage = () => {
  return (
    <div className="bg-[#f5f7fb] min-h-screen py-10 px-4">

      <div className="max-w-6xl mx-auto space-y-10">

        {/* 🔥 HEADER */}
        <div className="text-center">
          <h1 className="text-2xl md:text-3xl font-bold">
            Get in Touch with LappyShop
          </h1>
          <p className="text-gray-500 mt-2">
            Reliable • Cost-Effective • Corporate-Focused
          </p>
        </div>

        {/* 🔥 LOCATION CARD */}
<div className="bg-white rounded-2xl shadow-lg p-6 md:p-8 grid md:grid-cols-2 gap-6">

  {/* OFFICE */}
  <div>
   <h3 className="flex items-center gap-2 font-semibold text-lg mb-3">
  <FaMapMarkerAlt className="text-red-500" />
  Corporate Office (Noida)
</h3>

    <p className="text-gray-600 text-sm leading-relaxed">
      DIVINE TECHNOLOGY <br />
      Office No. 416, 4th Floor, Tower A <br />
      Bhutani Cyberpark, Block C <br />
      Plot No. C-28 & C-29, Sector-62 <br />
      Noida, Uttar Pradesh – 201309
    </p>

    <a
      href="https://www.google.com/maps?q=Bhutani+Cyberpark+Sector+62+Noida"
      target="_blank"
      rel="noreferrer"
      className="text-blue-600 text-sm font-medium mt-3 inline-block hover:underline"
    >
      📍 View on Map →
    </a>
  </div>

  {/* WAREHOUSE */}
  <div>
    <h3 className="font-semibold text-lg mb-3">
      Warehouse & Repair Center
    </h3>

    <p className="text-gray-600 text-sm leading-relaxed">
      C-4, 2nd Floor <br />
      Patparganj Industrial Area <br />
      New Delhi – 110092
    </p>
  </div>

</div>

{/* 🔥 MAP */}
<div className="rounded-2xl overflow-hidden shadow mt-6">
  <iframe
    title="Bhutani Cyberpark Map"
    src="https://maps.google.com/maps?q=Bhutani%20Cyberpark%20Sector%2062%20Noida&t=&z=15&ie=UTF8&iwloc=&output=embed"
    className="w-full h-[250px] md:h-[350px] border-0"
    loading="lazy"
  ></iframe>
</div>

        {/* 🔥 CONTACT CARDS */}
        <div className="grid md:grid-cols-3 gap-6">

          {/* SUPPORT */}
          <div className="bg-white p-6 rounded-2xl shadow hover:shadow-xl transition">

            <h3 className="font-semibold mb-3">
              Customer Support
            </h3>

            <p className="text-sm text-gray-600">
              📧{" "}
              <a href="mailto:support@lappyshop.com" className="text-blue-600">
                support@lappyshop.com
              </a>
            </p>

            <p className="text-sm text-gray-600 mt-2">
              📞{" "}
              <a href="tel:+918700074576" className="text-blue-600">
                +91-8700074576
              </a>
            </p>

            <p className="text-xs text-gray-400 mt-2">
              Response within 24 hrs
            </p>

          </div>

          {/* SALES */}
          <div className="bg-white p-6 rounded-2xl shadow hover:shadow-xl transition">

            <h3 className="font-semibold mb-3">
              Corporate Sales
            </h3>

            <p className="text-sm text-gray-600">
              Bulk orders & IT solutions
            </p>

            <p className="text-sm text-gray-600 mt-2">
              📞{" "}
              <a href="tel:+919560205329" className="text-blue-600">
                +91-9560205329
              </a>
            </p>

          </div>

          {/* BUSINESS */}
          <div className="bg-white p-6 rounded-2xl shadow hover:shadow-xl transition">

            <h3 className="font-semibold mb-3">
              Business & Partnerships
            </h3>

            <p className="text-sm text-gray-600">
              📧{" "}
              <a href="mailto:support@lappyshop.com" className="text-blue-600">
                support@lappyshop.com
              </a>
            </p>

            <p className="text-sm text-gray-600 mt-2">
              🌐{" "}
              <a
                href="https://www.lappyshop.com"
                target="_blank"
                rel="noreferrer"
                className="text-blue-600"
              >
                www.lappyshop.com
              </a>
            </p>

          </div>

        </div>

        {/* 🔥 ABOUT SECTION */}
        <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8">

          <h2 className="text-xl font-semibold mb-4">
            About Divine Technology
          </h2>

          <p className="text-gray-700 text-sm leading-relaxed mb-4">
            Divine Technology is a corporate-focused IT solutions company
            specializing in refurbished laptops, AMC services, buyback programs,
            and IT asset disposal (ITAD).
          </p>

          <p className="text-gray-700 text-sm leading-relaxed">
            We help startups, SMEs, and enterprises reduce IT costs while
            maintaining performance, reliability, and support.
          </p>

        </div>

      </div>

    </div>
  );
};

export default ContactPage;